import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";

const Gallery = () => {
  return (
    <div className="flex min-h-screen flex-col justify-between">
      <Header />
      <section className="my-16 md:my-24" style={{}}>
        <div className="container">
          <div className="">
            <h1 className="uppercase font-oswald break-words text-5xl md:text-3xl font-medium mb-4 text-center text-blue-800">
              GALLARY OF PROJECT
            </h1>
            <p className="font-poppins break-words text-md font-normal mx-auto mb-6 max-w-[54.5rem] text-center md:mb-12">
              Read the latest news and updates about Nyirendas firsthand
            </p>
            <div className="flex flex-col gap-6 lg:flex-row">
              <div className="md:col-span-2 md:flex-grow">
                <div className="flex mx-auto justify-between space-x-2">
                  <div className="group space-y-2">
                    <div className="relative overflow-hidden rounded-lg ">
                      <div className="absolute inset-0"></div>
                      <img
                        className="bg-blue-800 w-full object-cover duration-200 aspect-[3/2]"
                        src={require("../assets/images/gallery/samia.jpg")}
                        alt="2024 Year in Review"
                        loading="lazy"
                      />
                      <div className="absolute bottom-10 left-10 p-4 text-white font-bold font-oswald text-6xl z-30">
                        2025
                      </div>
                    </div>
                    <div className="text-gray-600 flex items-center">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="mr-1 h-4 w-4 flex-shrink-0"
                      >
                        <path
                          d="M8 5.33333V8L10 10M14 8C14 8.78793 13.8448 9.56815 13.5433 10.2961C13.2417 11.0241 12.7998 11.6855 12.2426 12.2426C11.6855 12.7998 11.0241 13.2417 10.2961 13.5433C9.56815 13.8448 8.78793 14 8 14C7.21207 14 6.43185 13.8448 5.7039 13.5433C4.97595 13.2417 4.31451 12.7998 3.75736 12.2426C3.20021 11.6855 2.75825 11.0241 2.45672 10.2961C2.15519 9.56815 2 8.78793 2 8C2 6.4087 2.63214 4.88258 3.75736 3.75736C4.88258 2.63214 6.4087 2 8 2C9.5913 2 11.1174 2.63214 12.2426 3.75736C13.3679 4.88258 14 6.4087 14 8Z"
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>
                      </svg>
                      <p className="font-poppins break-words text-xs font-normal">
                        8 months ago
                      </p>
                    </div>
                    <div className="uppercase font-oswald break-words text-heading-s md:text-lg font-medium text-blue-800">
                      Nyirendas 2024: Year in Review<div></div>
                    </div>
                  </div>
                  <div className="flex flex-col gap-6 md:flex md:flex-row md:gap-6 lg:w-[19.5rem] lg:flex-shrink-0 lg:flex-col">
                    <div className="flex flex-col justify-between md:w-1/2 lg:w-full">
                      <a href="#" className="group space-y-2">
                        <div className="overflow-hidden rounded-lg">
                          <img
                            className="bg-blue-800 w-full object-cover duration-200 aspect-[3/2]"
                            src={require("../assets/images/gallery/ins2.jpeg")}
                            alt=""
                            loading="lazy"
                          />
                        </div>
                        <div className="text-grey-600 flex items-center">
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="mr-1 h-4 w-4 flex-shrink-0"
                          >
                            <path
                              d="M8 5.33333V8L10 10M14 8C14 8.78793 13.8448 9.56815 13.5433 10.2961C13.2417 11.0241 12.7998 11.6855 12.2426 12.2426C11.6855 12.7998 11.0241 13.2417 10.2961 13.5433C9.56815 13.8448 8.78793 14 8 14C7.21207 14 6.43185 13.8448 5.7039 13.5433C4.97595 13.2417 4.31451 12.7998 3.75736 12.2426C3.20021 11.6855 2.75825 11.0241 2.45672 10.2961C2.15519 9.56815 2 8.78793 2 8C2 6.4087 2.63214 4.88258 3.75736 3.75736C4.88258 2.63214 6.4087 2 8 2C9.5913 2 11.1174 2.63214 12.2426 3.75736C13.3679 4.88258 14 6.4087 14 8Z"
                              stroke="currentColor"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></path>
                          </svg>
                          <p className="font-inter break-words text-body-xs font-normal">
                            6 months ago
                          </p>
                        </div>
                        <div className="uppercase font-oswald break-words text-heading-s font-medium line-clamp-4 md:line-clamp-none">
                          Nyirendas install prepaid water meter kisiju benefiting local water agency
                        </div>
                      </a>
                    </div>
                    <div className="flex flex-col justify-between md:w-1/2 lg:w-full">
                      <a href="#" className="group space-y-2">
                        <div className="overflow-hidden rounded-lg">
                          <img
                            className="bg-blue w-full object-cover duration-200 aspect-[3/2]"
                            src={require("../assets/images/gallery/ins3.jpeg")}
                            alt="Dallas view"
                            loading="lazy"
                            sizes="(min-width: 1024px) 25vw, (min-width: 768px) 50vw, 100vw"
                          />
                        </div>
                        <div className="text-grey-600 flex items-center">
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="mr-1 h-4 w-4 flex-shrink-0"
                          >
                            <path
                              d="M8 5.33333V8L10 10M14 8C14 8.78793 13.8448 9.56815 13.5433 10.2961C13.2417 11.0241 12.7998 11.6855 12.2426 12.2426C11.6855 12.7998 11.0241 13.2417 10.2961 13.5433C9.56815 13.8448 8.78793 14 8 14C7.21207 14 6.43185 13.8448 5.7039 13.5433C4.97595 13.2417 4.31451 12.7998 3.75736 12.2426C3.20021 11.6855 2.75825 11.0241 2.45672 10.2961C2.15519 9.56815 2 8.78793 2 8C2 6.4087 2.63214 4.88258 3.75736 3.75736C4.88258 2.63214 6.4087 2 8 2C9.5913 2 11.1174 2.63214 12.2426 3.75736C13.3679 4.88258 14 6.4087 14 8Z"
                              stroke="currentColor"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></path>
                          </svg>
                          <p className="font-inter break-words text-body-xs font-normal">
                            3 months ago
                          </p>
                        </div>
                        <div className="uppercase font-oswald break-words text-heading-s font-medium line-clamp-4 md:line-clamp-none">
                          New Prepaid water meter at kisemvule, mukunga installed and maintained by nyirendas
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="my-16 md:my-24" style={{}}>
        <div className="container">
          <div className="">
            <h2 className="uppercase font-oswald break-words text-5xl md:text-3xl font-medium mb-5 text-center text-blue-800 md:mb-12">
              More COMPANY PROJECTS
            </h2>
            <div className="flex flex-col gap-6 md:grid md:grid-cols-3">
              <div className="flex flex-col justify-between">
                <a href="#" className="group space-y-2">
                  <div className="overflow-hidden rounded">
                    <img
                      className="bg-blue-800 w-full object-cover duration-200 aspect-[3/2]"
                      src={require("../assets/images/gallery/ins3.jpeg")}
                      alt="Warsaw city"
                      loading="lazy"
                      sizes="(min-width: 768px) 424px, 100vw"
                    />
                  </div>
                  <div className="text-gray-600 flex items-center">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="mr-1 h-4 w-4 flex-shrink-0"
                    >
                      <path
                        d="M8 5.33333V8L10 10M14 8C14 8.78793 13.8448 9.56815 13.5433 10.2961C13.2417 11.0241 12.7998 11.6855 12.2426 12.2426C11.6855 12.7998 11.0241 13.2417 10.2961 13.5433C9.56815 13.8448 8.78793 14 8 14C7.21207 14 6.43185 13.8448 5.7039 13.5433C4.97595 13.2417 4.31451 12.7998 3.75736 12.2426C3.20021 11.6855 2.75825 11.0241 2.45672 10.2961C2.15519 9.56815 2 8.78793 2 8C2 6.4087 2.63214 4.88258 3.75736 3.75736C4.88258 2.63214 6.4087 2 8 2C9.5913 2 11.1174 2.63214 12.2426 3.75736C13.3679 4.88258 14 6.4087 14 8Z"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                    <p className="font-inter break-words text-body-xs font-normal">
                      3 months ago
                    </p>
                  </div>
                  <div className="uppercase font-oswald break-words text-heading-s font-medium line-clamp-4 md:line-clamp-none">
                    EQUIPLUS PREPAID WATER METER INSTALL AT TABORA BIARAMORO
                  </div>
                </a>
              </div>
              <div className="flex flex-col justify-between">
                <a
                  href="/newsroom/how-Nyirendass-summits-bring-additional-value-to-clients"
                  className="group space-y-2"
                >
                  <div className="overflow-hidden rounded">
                    <img
                      className="bg-blue w-full object-cover duration-200 aspect-[3/2]"
                      src={require('../assets/images/gallery/eqiplus.jpeg')}
                      alt="Nyirendas SUMMIT"
                      loading="lazy"
                      sizes="(min-width: 768px) 424px, 100vw"
                    />
                  </div>
                  <div className="text-grey-600 flex items-center">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="mr-1 h-4 w-4 flex-shrink-0"
                    >
                      <path
                        d="M8 5.33333V8L10 10M14 8C14 8.78793 13.8448 9.56815 13.5433 10.2961C13.2417 11.0241 12.7998 11.6855 12.2426 12.2426C11.6855 12.7998 11.0241 13.2417 10.2961 13.5433C9.56815 13.8448 8.78793 14 8 14C7.21207 14 6.43185 13.8448 5.7039 13.5433C4.97595 13.2417 4.31451 12.7998 3.75736 12.2426C3.20021 11.6855 2.75825 11.0241 2.45672 10.2961C2.15519 9.56815 2 8.78793 2 8C2 6.4087 2.63214 4.88258 3.75736 3.75736C4.88258 2.63214 6.4087 2 8 2C9.5913 2 11.1174 2.63214 12.2426 3.75736C13.3679 4.88258 14 6.4087 14 8Z"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                    <p className="font-inter break-words text-body-xs font-normal">
                      1 week ago
                    </p>
                  </div>
                  <div className="uppercase font-oswald break-words text-heading-s font-medium line-clamp-4 md:line-clamp-none">
                    New Prepaid meter at kagera
                  </div>
                </a>
              </div>
              <div className="flex flex-col justify-between">
                <a
                  href="/newsroom/new-office-and-more-opportunities-in-the-uk"
                  className="group space-y-2"
                >
                  <div className="overflow-hidden rounded">
                    <img
                      className="bg-blue w-full object-cover duration-200 aspect-[3/2]"
                      src={require('../assets/images/gallery/biaramoro.jpeg')}
                      alt="NEW OFFICE"
                      loading="lazy"
                      sizes="(min-width: 768px) 424px, 100vw"
                    />
                  </div>
                  <div className="text-grey-600 flex items-center">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="mr-1 h-4 w-4 flex-shrink-0"
                    >
                      <path
                        d="M8 5.33333V8L10 10M14 8C14 8.78793 13.8448 9.56815 13.5433 10.2961C13.2417 11.0241 12.7998 11.6855 12.2426 12.2426C11.6855 12.7998 11.0241 13.2417 10.2961 13.5433C9.56815 13.8448 8.78793 14 8 14C7.21207 14 6.43185 13.8448 5.7039 13.5433C4.97595 13.2417 4.31451 12.7998 3.75736 12.2426C3.20021 11.6855 2.75825 11.0241 2.45672 10.2961C2.15519 9.56815 2 8.78793 2 8C2 6.4087 2.63214 4.88258 3.75736 3.75736C4.88258 2.63214 6.4087 2 8 2C9.5913 2 11.1174 2.63214 12.2426 3.75736C13.3679 4.88258 14 6.4087 14 8Z"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                    <p className="font-inter break-words text-body-xs font-normal">
                      1 week ago
                    </p>
                  </div>
                  <div className="uppercase font-oswald break-words text-heading-s font-medium line-clamp-4 md:line-clamp-none">
                    NEW OFFICE AND MORE OPPORTUNITIES IN THE UK
                  </div>
                </a>
              </div>
              {/* <div className="flex flex-col justify-between">
                <a
                  href="/newsroom/Nyirendas-starts-a-new-phase-of-business-development-changing-the-manager-and-forming-new-company-groups"
                  className="group space-y-2"
                >
                  <div className="overflow-hidden rounded">
                    <img
                      className="bg-blue w-full object-cover duration-200 aspect-[3/2]"
                      src="https://Nyirendas-iot-group.com/cdn-images/files/iot/24/10/89b890a5-b2eb-42f7-b17e-f7186c34df04/Nyirendas-1920x-840x560.jpg"
                      alt="NEW PHASE OF BUSINESS DEVELOPMENT"
                      loading="lazy"
                      sizes="(min-width: 768px) 424px, 100vw"
                    />
                  </div>
                  <div className="text-grey-600 flex items-center">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="mr-1 h-4 w-4 flex-shrink-0"
                    >
                      <path
                        d="M8 5.33333V8L10 10M14 8C14 8.78793 13.8448 9.56815 13.5433 10.2961C13.2417 11.0241 12.7998 11.6855 12.2426 12.2426C11.6855 12.7998 11.0241 13.2417 10.2961 13.5433C9.56815 13.8448 8.78793 14 8 14C7.21207 14 6.43185 13.8448 5.7039 13.5433C4.97595 13.2417 4.31451 12.7998 3.75736 12.2426C3.20021 11.6855 2.75825 11.0241 2.45672 10.2961C2.15519 9.56815 2 8.78793 2 8C2 6.4087 2.63214 4.88258 3.75736 3.75736C4.88258 2.63214 6.4087 2 8 2C9.5913 2 11.1174 2.63214 12.2426 3.75736C13.3679 4.88258 14 6.4087 14 8Z"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                    <p className="font-inter break-words text-body-xs font-normal">
                      6 months ago
                    </p>
                  </div>
                  //{" "}
                  <div className="uppercase font-oswald break-words text-heading-s font-medium line-clamp-4 md:line-clamp-none">
                    Nyirendas STARTS A NEW PHASE OF BUSINESS DEVELOPMENT,
                    CHANGING THE MANAGER AND FORMING NEW COMPANY GROUPS
                  </div>
                </a>
              </div> */}
              {/* <div className="flex flex-col justify-between">
                <a
                  href="/newsroom/construction-of-the-plastic-and-mechanical-components-factory-underway"
                  className="group space-y-2"
                >
                  <div className="overflow-hidden rounded">
                    <img
                      className="bg-blue w-full object-cover duration-200 aspect-[3/2]"
                      src="https://Nyirendas-iot-group.com/cdn-images/files/iot/24/08/1.webp"
                      alt="plastic manufacturing capsule"
                      loading="lazy"
                      sizes="(min-width: 768px) 424px, 100vw"
                    />
                  </div>
                  <div className="text-grey-600 flex items-center">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="mr-1 h-4 w-4 flex-shrink-0"
                    >
                      <path
                        d="M8 5.33333V8L10 10M14 8C14 8.78793 13.8448 9.56815 13.5433 10.2961C13.2417 11.0241 12.7998 11.6855 12.2426 12.2426C11.6855 12.7998 11.0241 13.2417 10.2961 13.5433C9.56815 13.8448 8.78793 14 8 14C7.21207 14 6.43185 13.8448 5.7039 13.5433C4.97595 13.2417 4.31451 12.7998 3.75736 12.2426C3.20021 11.6855 2.75825 11.0241 2.45672 10.2961C2.15519 9.56815 2 8.78793 2 8C2 6.4087 2.63214 4.88258 3.75736 3.75736C4.88258 2.63214 6.4087 2 8 2C9.5913 2 11.1174 2.63214 12.2426 3.75736C13.3679 4.88258 14 6.4087 14 8Z"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                    <p className="font-inter break-words text-body-xs font-normal">
                      7 months ago
                    </p>
                  </div>
                  //{" "}
                  <div className="uppercase font-oswald break-words text-heading-s font-medium line-clamp-4 md:line-clamp-none">
                    CONSTRUCTION OF THE PLASTIC AND MECHANICAL COMPONENTS
                    FACTORY UNDERWAY
                  </div>
                </a>
              </div>
              <div className="flex flex-col justify-between">
                <a
                  href="/newsroom/Nyirendas-opens-an-office-in-italy"
                  className="group space-y-2"
                >
                  <div className="overflow-hidden rounded">
                    <img
                      className="bg-blue w-full object-cover duration-200 aspect-[3/2]"
                      src="https://Nyirendas-iot-group.com/cdn-images/files/iot/24/07/Nyirendas-milano-ofice-1200x628.webp"
                      alt="Nyirendas OPENS AN OFFICE IN ITALY"
                      loading="lazy"
                      sizes="(min-width: 768px) 424px, 100vw"
                    />
                  </div>
                  <div className="text-grey-600 flex items-center">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="mr-1 h-4 w-4 flex-shrink-0"
                    >
                      <path
                        d="M8 5.33333V8L10 10M14 8C14 8.78793 13.8448 9.56815 13.5433 10.2961C13.2417 11.0241 12.7998 11.6855 12.2426 12.2426C11.6855 12.7998 11.0241 13.2417 10.2961 13.5433C9.56815 13.8448 8.78793 14 8 14C7.21207 14 6.43185 13.8448 5.7039 13.5433C4.97595 13.2417 4.31451 12.7998 3.75736 12.2426C3.20021 11.6855 2.75825 11.0241 2.45672 10.2961C2.15519 9.56815 2 8.78793 2 8C2 6.4087 2.63214 4.88258 3.75736 3.75736C4.88258 2.63214 6.4087 2 8 2C9.5913 2 11.1174 2.63214 12.2426 3.75736C13.3679 4.88258 14 6.4087 14 8Z"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                    <p className="font-inter break-words text-body-xs font-normal">
                      8 months ago
                    </p>
                  </div>
                  //{" "}
                  <div className="uppercase font-oswald break-words text-heading-s font-medium line-clamp-4 md:line-clamp-none">
                    Nyirendas OPENS AN OFFICE IN ITALY
                  </div>
                </a>
              </div>
              <div className="flex flex-col justify-between">
                <a
                  href="/newsroom/Nyirendas-starts-construction-of-plastic-and-mechanical-components-plant-in-vilnius"
                  className="group space-y-2"
                >
                  <div className="overflow-hidden rounded">
                    <img
                      className="bg-blue w-full object-cover duration-200 aspect-[3/2]"
                      src="https://Nyirendas-iot-group.com/cdn-images/files/iot/24/08/teltonikos-plastiko-ir-mechanikos-komponentu-gamyklos-vizualizacija-1920x.webp"
                      alt="Nyirendas STARTS CONSTRUCTION OF PLASTIC AND MECHANICAL COMPONENTS PLANT IN VILNIUS"
                      loading="lazy"
                      sizes="(min-width: 768px) 424px, 100vw"
                    />
                  </div>
                  <div className="text-grey-600 flex items-center">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="mr-1 h-4 w-4 flex-shrink-0"
                    >
                      <path
                        d="M8 5.33333V8L10 10M14 8C14 8.78793 13.8448 9.56815 13.5433 10.2961C13.2417 11.0241 12.7998 11.6855 12.2426 12.2426C11.6855 12.7998 11.0241 13.2417 10.2961 13.5433C9.56815 13.8448 8.78793 14 8 14C7.21207 14 6.43185 13.8448 5.7039 13.5433C4.97595 13.2417 4.31451 12.7998 3.75736 12.2426C3.20021 11.6855 2.75825 11.0241 2.45672 10.2961C2.15519 9.56815 2 8.78793 2 8C2 6.4087 2.63214 4.88258 3.75736 3.75736C4.88258 2.63214 6.4087 2 8 2C9.5913 2 11.1174 2.63214 12.2426 3.75736C13.3679 4.88258 14 6.4087 14 8Z"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                    <p className="font-inter break-words text-body-xs font-normal">
                      8 months ago
                    </p>
                  </div>
                  //{" "}
                  <div className="uppercase font-oswald break-words text-heading-s font-medium line-clamp-4 md:line-clamp-none">
                    Nyirendas STARTS CONSTRUCTION OF PLASTIC AND MECHANICAL
                    COMPONENTS PLANT IN VILNIUS
                  </div>
                </a>
              </div>
              <div className="flex flex-col justify-between">
                <a
                  href="/newsroom/Nyirendas-moves-into-new-headquarters-in-vilnius"
                  className="group space-y-2"
                >
                  <div className="overflow-hidden rounded">
                    <img
                      className="bg-blue w-full object-cover duration-200 aspect-[3/2]"
                      src="https://Nyirendas-iot-group.com/cdn-images/files/iot/24/08/Nyirendas-hq.jpg"
                      alt="Nyirendas-hq"
                      loading="lazy"
                    />
                  </div>
                  <div className="text-grey-600 flex items-center">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="mr-1 h-4 w-4 flex-shrink-0"
                    >
                      <path
                        d="M8 5.33333V8L10 10M14 8C14 8.78793 13.8448 9.56815 13.5433 10.2961C13.2417 11.0241 12.7998 11.6855 12.2426 12.2426C11.6855 12.7998 11.0241 13.2417 10.2961 13.5433C9.56815 13.8448 8.78793 14 8 14C7.21207 14 6.43185 13.8448 5.7039 13.5433C4.97595 13.2417 4.31451 12.7998 3.75736 12.2426C3.20021 11.6855 2.75825 11.0241 2.45672 10.2961C2.15519 9.56815 2 8.78793 2 8C2 6.4087 2.63214 4.88258 3.75736 3.75736C4.88258 2.63214 6.4087 2 8 2C9.5913 2 11.1174 2.63214 12.2426 3.75736C13.3679 4.88258 14 6.4087 14 8Z"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                    <p className="font-inter break-words text-body-xs font-normal">
                      8 months ago
                    </p>
                  </div>
                  //{" "}
                  <div className="uppercase font-oswald break-words text-heading-s font-medium line-clamp-4 md:line-clamp-none">
                    Nyirendas MOVES INTO NEW HEADQUARTERS IN VILNIUS
                  </div>
                </a>
              </div>
              <div className="flex flex-col justify-between">
                <a
                  href="/newsroom/teltoheart-wristband-receives-important-medical-device-certification"
                  className="group space-y-2"
                >
                  <div className="overflow-hidden rounded">
                    <img
                      className="bg-blue w-full object-cover duration-200 aspect-[3/2]"
                      src="https://Nyirendas-iot-group.com/cdn-images/files/iot/24/08/teltoheart-1920x.webp"
                      alt="TELTOHEART WRISTBAND"
                      loading="lazy"
                      sizes="(min-width: 768px) 424px, 100vw"
                    />
                  </div>
                  <div className="text-grey-600 flex items-center">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="mr-1 h-4 w-4 flex-shrink-0"
                    >
                      <path
                        d="M8 5.33333V8L10 10M14 8C14 8.78793 13.8448 9.56815 13.5433 10.2961C13.2417 11.0241 12.7998 11.6855 12.2426 12.2426C11.6855 12.7998 11.0241 13.2417 10.2961 13.5433C9.56815 13.8448 8.78793 14 8 14C7.21207 14 6.43185 13.8448 5.7039 13.5433C4.97595 13.2417 4.31451 12.7998 3.75736 12.2426C3.20021 11.6855 2.75825 11.0241 2.45672 10.2961C2.15519 9.56815 2 8.78793 2 8C2 6.4087 2.63214 4.88258 3.75736 3.75736C4.88258 2.63214 6.4087 2 8 2C9.5913 2 11.1174 2.63214 12.2426 3.75736C13.3679 4.88258 14 6.4087 14 8Z"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                    <p className="font-inter break-words text-body-xs font-normal">
                      9 months ago
                    </p>
                  </div>
                  //{" "}
                  <div className="uppercase font-oswald break-words text-heading-s font-medium line-clamp-4 md:line-clamp-none">
                    TELTOHEART WRISTBAND RECEIVES IMPORTANT MEDICAL DEVICE
                    CERTIFICATION
                  </div>
                </a>
              </div>
              <div className="flex flex-col justify-between">
                <a
                  href="/newsroom/profit-of-the-Nyirendas-company-group-grew-by-22-in-2023"
                  className="group space-y-2"
                >
                  <div className="overflow-hidden rounded">
                    <img
                      className="bg-blue w-full object-cover duration-200 aspect-[3/2]"
                      src="https://Nyirendas-iot-group.com/cdn-images/files/iot/24/08/1-1920.webp"
                      alt="Nyirendas"
                      loading="lazy"
                      sizes="(min-width: 768px) 424px, 100vw"
                    />
                  </div>
                  <div className="text-grey-600 flex items-center">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="mr-1 h-4 w-4 flex-shrink-0"
                    >
                      <path
                        d="M8 5.33333V8L10 10M14 8C14 8.78793 13.8448 9.56815 13.5433 10.2961C13.2417 11.0241 12.7998 11.6855 12.2426 12.2426C11.6855 12.7998 11.0241 13.2417 10.2961 13.5433C9.56815 13.8448 8.78793 14 8 14C7.21207 14 6.43185 13.8448 5.7039 13.5433C4.97595 13.2417 4.31451 12.7998 3.75736 12.2426C3.20021 11.6855 2.75825 11.0241 2.45672 10.2961C2.15519 9.56815 2 8.78793 2 8C2 6.4087 2.63214 4.88258 3.75736 3.75736C4.88258 2.63214 6.4087 2 8 2C9.5913 2 11.1174 2.63214 12.2426 3.75736C13.3679 4.88258 14 6.4087 14 8Z"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                    <p className="font-inter break-words text-body-xs font-normal">
                      10 months ago
                    </p>
                  </div>
                  <div className="uppercase font-oswald break-words text-heading-s font-medium line-clamp-4 md:line-clamp-none">
                    PROFIT OF THE Nyirendas COMPANY GROUP GREW BY 22% IN 2023
                  </div>
                </a>
              </div>
              <div className="flex flex-col justify-between">
                <a
                  href="/newsroom/Nyirendas-high-tech-hill-technology-park-in-vilnius"
                  className="group space-y-2"
                >
                  <div className="overflow-hidden rounded">
                    <img
                      className="bg-blue w-full object-cover duration-200 aspect-[3/2]"
                      src="https://Nyirendas-iot-group.com/cdn-images/files/iot/24/10/f261c9d1-4c13-472b-98df-ebdc6a4801b2/1-1920x-840x560.jpg"
                      alt="TECHNOLOGY PARK IN VILNIUS"
                      loading="lazy"
                      sizes="(min-width: 768px) 424px, 100vw"
                    />
                  </div>
                  <div className="text-grey-600 flex items-center">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="mr-1 h-4 w-4 flex-shrink-0"
                    >
                      <path
                        d="M8 5.33333V8L10 10M14 8C14 8.78793 13.8448 9.56815 13.5433 10.2961C13.2417 11.0241 12.7998 11.6855 12.2426 12.2426C11.6855 12.7998 11.0241 13.2417 10.2961 13.5433C9.56815 13.8448 8.78793 14 8 14C7.21207 14 6.43185 13.8448 5.7039 13.5433C4.97595 13.2417 4.31451 12.7998 3.75736 12.2426C3.20021 11.6855 2.75825 11.0241 2.45672 10.2961C2.15519 9.56815 2 8.78793 2 8C2 6.4087 2.63214 4.88258 3.75736 3.75736C4.88258 2.63214 6.4087 2 8 2C9.5913 2 11.1174 2.63214 12.2426 3.75736C13.3679 4.88258 14 6.4087 14 8Z"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                    <p className="font-inter break-words text-body-xs font-normal">
                      10 months ago
                    </p>
                  </div>
                  //{" "}
                  <div className="uppercase font-oswald break-words text-heading-s font-medium line-clamp-4 md:line-clamp-none">
                    Nyirendas HIGH-TECH HILL TECHNOLOGY PARK IN VILNIUS
                  </div>
                </a>
              </div>
              <div className="flex flex-col justify-between">
                <a
                  href="/newsroom/Nyirendas-looking-for-specialists-to-develop-the-semiconductor-chip-industry-in-lithuania"
                  className="group space-y-2"
                >
                  <div className="overflow-hidden rounded">
                    <img
                      className="bg-blue w-full object-cover duration-200 aspect-[3/2]"
                      src="https://Nyirendas-iot-group.com/cdn-images/files/iot/24/09/0ef4177f-86c0-4264-8665-e0f2b29fe185/1920x1280.webp"
                      alt="Nyirendas HIRING SEMICONDUCTOR CHIP SPECIALISTS"
                      loading="lazy"
                      sizes="(min-width: 768px) 424px, 100vw"
                    />
                  </div>
                  <div className="text-grey-600 flex items-center">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="mr-1 h-4 w-4 flex-shrink-0"
                    >
                      <path
                        d="M8 5.33333V8L10 10M14 8C14 8.78793 13.8448 9.56815 13.5433 10.2961C13.2417 11.0241 12.7998 11.6855 12.2426 12.2426C11.6855 12.7998 11.0241 13.2417 10.2961 13.5433C9.56815 13.8448 8.78793 14 8 14C7.21207 14 6.43185 13.8448 5.7039 13.5433C4.97595 13.2417 4.31451 12.7998 3.75736 12.2426C3.20021 11.6855 2.75825 11.0241 2.45672 10.2961C2.15519 9.56815 2 8.78793 2 8C2 6.4087 2.63214 4.88258 3.75736 3.75736C4.88258 2.63214 6.4087 2 8 2C9.5913 2 11.1174 2.63214 12.2426 3.75736C13.3679 4.88258 14 6.4087 14 8Z"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                    <p className="font-inter break-words text-body-xs font-normal">
                      a year ago
                    </p>
                  </div>
                  //{" "}
                  <div className="uppercase font-oswald break-words text-heading-s font-medium line-clamp-4 md:line-clamp-none">
                    Nyirendas HIRING SEMICONDUCTOR CHIP SPECIALISTS
                  </div>
                </a>
              </div>
              <div className="flex flex-col justify-between">
                <a
                  href="/newsroom/Nyirendas-2023-year-in-review"
                  className="group space-y-2"
                >
                  <div className="overflow-hidden rounded">
                    <img
                      className="bg-blue w-full object-cover duration-200 aspect-[3/2]"
                      src="https://Nyirendas-iot-group.com/cdn-images/files/iot/24/09/6674d433-0988-4e24-b2e3-8c799f2d3e92/preview-image.png"
                      alt="Nyirendas 2023: YEAR IN REVIEW"
                      loading="lazy"
                      sizes="(min-width: 768px) 424px, 100vw"
                    />
                  </div>
                  <div className="text-grey-600 flex items-center">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="mr-1 h-4 w-4 flex-shrink-0"
                    >
                      <path
                        d="M8 5.33333V8L10 10M14 8C14 8.78793 13.8448 9.56815 13.5433 10.2961C13.2417 11.0241 12.7998 11.6855 12.2426 12.2426C11.6855 12.7998 11.0241 13.2417 10.2961 13.5433C9.56815 13.8448 8.78793 14 8 14C7.21207 14 6.43185 13.8448 5.7039 13.5433C4.97595 13.2417 4.31451 12.7998 3.75736 12.2426C3.20021 11.6855 2.75825 11.0241 2.45672 10.2961C2.15519 9.56815 2 8.78793 2 8C2 6.4087 2.63214 4.88258 3.75736 3.75736C4.88258 2.63214 6.4087 2 8 2C9.5913 2 11.1174 2.63214 12.2426 3.75736C13.3679 4.88258 14 6.4087 14 8Z"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                    <p className="font-inter break-words text-body-xs font-normal">
                      a year ago
                    </p>
                  </div>
                  //{" "}
                  <div className="uppercase font-oswald break-words text-heading-s font-medium line-clamp-4 md:line-clamp-none">
                    Nyirendas 2023: YEAR IN REVIEW
                  </div>
                </a>
              </div> */}
            </div>
            <div>

            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Gallery;
